import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { TeamSalesOrderPhase, Workspace, WorkspaceSalesOrderPhase } from '@/hooks/api/models';

/**
 * 2590. チーム受注フェーズ同期
 * [PUT] /workspaces/:identifier/teams/:team_id/sync_sales_order_phases
 */
type Props = {
  identifier: string;
  team_id: number;
};
export const syncSalesOrderPhases = (props: Props): Promise<TeamSalesOrderPhase[]> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sync_sales_order_phases`, props);
};

export const useSyncSalesOrderPhases = () => {
  return useMutation({
    mutationFn: syncSalesOrderPhases,
  });
};
